import moment from 'moment';
import { expectedDaysOptions } from './constants';
import { UserProfession, UserSubProfession } from '../../../../enums/UserProfession';
import { EnumHelper } from '../../../../utils/EnumHelper';
import { Colors } from '../../../../themes/colors';

export const getDayNameByCode = (code) => {
  const day = expectedDaysOptions.find((day) => day.code === code);
  return day ? day.name : '';
};

export const getPayRateSuffix = (payType) => {
  switch (payType?.toLowerCase()) {
    case 'hourly':
      return '/hour';
    case 'salary':
      return '/year';
    case 'daily':
      return '/day';
    default:
      return '';
  }
};

export const formatDate = (date, format = 'YYYY-MM-DD') => {
  if (!date) return '';
  const parsedDate = moment(date);
  return parsedDate.isValid() ? parsedDate.format(format) : '';
};

export const isSubProfession = (code) =>
  EnumHelper.getObjectKeys(UserSubProfession).includes(code);

export const getProfessionName = (job) => {
  if (!job) return '';

  return (
    UserSubProfession.getName(job?.subProfession) || UserProfession.getName(job?.professionType)
  );
};

export const getProfessionCode = (job) => {
  if (!job) return '';

  return job?.subProfession || job?.professionType;
}

export const getErrorStyle = (hasError) => {
  if (hasError) {
    return { border: `1px solid ${Colors.error_400}`, backgroundColor: '#FEF9F9' };
  }

  return {};
};
